import React, { useState, useEffect } from 'react';

import { useHawksearch, ResultItemProps, ResultImage, TrackingEvent } from 'react-hawksearch';
import ComparisionDialog from './ComparisionDialog';

function ExtendedResultItem({ item }: ResultItemProps) {
	const [showComparison, setShowComparison] = useState(false);
	const [showComparisionDialog, setShowComparisionDialog] = useState(false);

	const imageURL = item.getDocumentValue('image') || '';

	const nameValue = item.getDocumentValue('name') || '';
	const pageURL = item.getDocumentValue('url_detail') || '';
	const sku = item.getDocumentValue('sku') || '';
	const bestFragment = item.BestFragment || '';
	const contentTypeValue = item.getDocumentValue('content_type') || '';

	function DrawingUrlClick(e, filetype: string, url: string, redir: string) {
		window['drawing_file_url_click'](filetype, url, redir, sku);
		e.preventDefault();
	}
	function trackClickEvent(e, url = '') {
		TrackingEvent.track('click', {
			event: e,
			uniqueId: item.DocId,
			trackingId: localStorage.getItem('tracking-id'),
			url,
		});
	}

	if (item.getDocumentValue('it') === 'Content') {
		return (
			<li className="hawk-results__contentItem">
				<a className="match-title-height title-link" href={pageURL}>
					<h5 onClick={e => trackClickEvent(e, pageURL)} className="title">
						{nameValue}
					</h5>
				</a>
				<p className="article-date">{contentTypeValue}</p>
				{bestFragment ? (
					<div className="article-summary" dangerouslySetInnerHTML={{ __html: bestFragment }} />
				) : null}
			</li>
		);
	} else {
		const retailPrice = null; // item.getDocumentValue('price_retail'); // pricing section is disabled per PM request
		const salePrice = null; // getSalesPriceStr(docSalePrice); // pricing section is disabled per PM request
		const pdfDrawingUrl = item.getDocumentValue('pdf_drawing_url');
		const stepDrawingUrl = item.getDocumentValue('step_drawing_url');
		const dxfDrawingUrl = item.getDocumentValue('dxf_drawing_url');
		const instock = item.getDocumentValue('instock');
		const itemType = item.getDocumentValue('itemtype');
		const descriptionShort = item.getDocumentValue('description_short');
		const isSnapEda = item.getDocumentValue('is_snapeda_available');

		return (
			<li className={'hawk-results__item' + (!item.IsVisible ? 'hidden' : '')}>
				<div className="hawk-results__item-innerWrapper ">
					<div className="image-wrapper match-image-height">
						<a className="item-link" href={pageURL}>
							<ResultImage item={item} imageUrl={imageURL} imageTitle={nameValue} />
						</a>
					</div>
					<div className="item-content">
						{sku ? (
							<div>
								<a className="item-title match-title-height" href={pageURL}>
									<span className="product-sku" onClick={e => trackClickEvent(e, pageURL)}>
										{itemType === 'Parent' ? nameValue : sku}
									</span>
								</a>
								<span className="product-title">
									{itemType === 'Parent' ? descriptionShort : nameValue}
								</span>
							</div>
						) : (
							<div>
								<a className="item-title match-title-height" href={pageURL}>
									<span className="product-title" onClick={e => trackClickEvent(e, pageURL)}>
										{nameValue}
									</span>
								</a>
							</div>
						)}
						<div className="match-price-height price-hawk-wrap">
							{retailPrice ? (
								<div
									data-test-selector="divPrice"
									className="price-wrapper"
									data-sku={sku ? sku : 'nosku'}
									data-type="SimpleProduct"
								>
									<span className="product-price">Retail Price: </span>
									<span data-test-selector="spanPrice" className="product-price red">
										{new Intl.NumberFormat('en-US', {
											style: 'currency',
											currency: 'USD',
										}).format(retailPrice)}
									</span>
								</div>
							) : null}
							{salePrice ? (
								<div
									data-test-selector="divPrice"
									className="price-wrapper"
									data-sku={sku ? sku : 'nosku'}
									data-type="SimpleProduct"
								>
									<span className="product-price">Sale Price: </span>
									<span data-test-selector="spanPrice" className="product-price red">
										{new Intl.NumberFormat('en-US', {
											style: 'currency',
											currency: 'USD',
										}).format(salePrice)}
									</span>
								</div>
							) : null}
						</div>
						{instock ? (
							instock === 'Yes' ? (
								<div className="status in-stock">
									<a href={'/catalog/stock-check/?sku=' + (sku ? sku : '')}>In stock</a>
								</div>
							) : (
								<div className="status out-stock">
									<a href={'/catalog/stock-check/?sku=' + (sku ? sku : '')}>out of stock</a>
								</div>
							)
						) : null}
						<div className="drawings">
							{pdfDrawingUrl ? (
								<a
									href="#"
									onClick={e =>
										DrawingUrlClick(e, 'pdf', pdfDrawingUrl, location.pathname + location.search)
									}
								>
									<svg className="icon icon-pdf" focusable="false">
										<use xlinkHref="#icon-pdf">PDF</use>
									</svg>
								</a>
							) : null}
							{stepDrawingUrl ? (
								<a
									href="#"
									onClick={e =>
										DrawingUrlClick(e, 'step', stepDrawingUrl, location.pathname + location.search)
									}
								>
									<svg className="icon icon-step" focusable="false">
										<use xlinkHref="#icon-step">step</use>
									</svg>
								</a>
							) : null}
							{dxfDrawingUrl ? (
								<a
									href="#"
									onClick={e =>
										DrawingUrlClick(e, 'dxf', dxfDrawingUrl, location.pathname + location.search)
									}
								>
									<svg className="icon icon-dfx" focusable="false">
										<use xlinkHref="#icon-dfx">dfx</use>
									</svg>
								</a>
							) : null}
							{isSnapEda ? (
								<a
								href={"/snap-eda/?sku=" + (sku || "")}
							>
								<svg className="icon icon-pcb" focusable="false">
									<use xlinkHref="#icon-pcb">pcb</use>
								</svg>
							</a>
							) : null}
						</div>
						<a href={pageURL} className="more">
							View Details
						</a>
					</div>

					<ComparisionDialog
						showComparison={showComparison}
						isOpen={showComparisionDialog}
						onToggleModal={setShowComparisionDialog}
					/>
				</div>
			</li>
		);
	}
}

export default ExtendedResultItem;
